export default __webpack_public_path__ + "static/media/customer.475788eb.svg";